import {
  formatIndexComponentWeight,
  parseIndexComponentRows,
} from '@/lib/indexComponentsDisplay';
import './IndexComponentsStrip.css';

type LegProps = {
  exchange: string;
  instId: string;
  payload: Record<string, unknown> | null | undefined;
};

function IndexComponentsLeg({ exchange, instId, payload }: LegProps) {
  const rows = parseIndexComponentRows(payload);
  if (rows.length === 0) return null;

  const indexLabel =
    payload && typeof payload.index === 'string'
      ? payload.index
      : payload && typeof payload.indexName === 'string'
        ? payload.indexName
        : payload && typeof payload.symbol === 'string'
          ? payload.symbol
          : instId;

  return (
    <section className="index-components-leg">
      <header className="index-components-leg-head">
        <b>{exchange}</b>
        <span className="index-components-leg-title">{indexLabel}</span>
        <span className="index-components-leg-count">{rows.length} 成分</span>
      </header>
      <div className="index-components-table-wrap">
        <table className="index-components-table">
          <thead>
            <tr>
              <th>Exchange</th>
              <th>Symbol</th>
              <th className="num">Weight</th>
              <th className="num">Price</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={`${exchange}-${row.exchange ?? 'na'}-${row.symbol}-${index}`}>
                <td>{row.exchange ?? '—'}</td>
                <td>{row.symbol}</td>
                <td className="num">{formatIndexComponentWeight(row.weight)}</td>
                <td className="num">{row.price ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

type PanelProps = {
  exchange1: string;
  exchange2: string;
  instId1: string;
  instId2: string;
  indexComponents1: Record<string, unknown> | null | undefined;
  indexComponents2: Record<string, unknown> | null | undefined;
};

export function IndexComponentsPanel({
  exchange1,
  exchange2,
  instId1,
  instId2,
  indexComponents1,
  indexComponents2,
}: PanelProps) {
  const leg1 = parseIndexComponentRows(indexComponents1);
  const leg2 = parseIndexComponentRows(indexComponents2);
  if (leg1.length === 0 && leg2.length === 0) {
    return <div className="index-components-panel-empty">暂无 Index 成分数据</div>;
  }

  return (
    <div className="index-components-panel">
      <IndexComponentsLeg exchange={exchange1} instId={instId1} payload={indexComponents1} />
      <IndexComponentsLeg exchange={exchange2} instId={instId2} payload={indexComponents2} />
    </div>
  );
}

export function IndexComponentsStrip({
  exchange1,
  exchange2,
  instId1,
  instId2,
  indexComponents1,
  indexComponents2,
}: PanelProps) {
  const leg1 = parseIndexComponentRows(indexComponents1);
  const leg2 = parseIndexComponentRows(indexComponents2);
  if (leg1.length === 0 && leg2.length === 0) return null;

  return (
    <details className="index-components-strip">
      <summary className="index-components-strip-summary">
        <span className="index-components-strip-chevron" aria-hidden="true" />
        Index 成分
        <span className="index-components-strip-badge">
          {leg1.length + leg2.length} 项
        </span>
      </summary>
      <div className="index-components-strip-body">
        <IndexComponentsLeg exchange={exchange1} instId={instId1} payload={indexComponents1} />
        <IndexComponentsLeg exchange={exchange2} instId={instId2} payload={indexComponents2} />
      </div>
    </details>
  );
}
